import React from "react";
import { useLenis } from "../hooks/useLenis";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { MarqueeRibbon } from "../components/MarqueeRibbon";
import { About } from "../components/About";
import { AboutUs } from "../components/AboutUs";
import { Rooms } from "../components/Rooms";
import { Gallery } from "../components/Gallery";
import { Included } from "../components/Included";
import { Location } from "../components/Location";
import { Reviews } from "../components/Reviews";
import { Footer } from "../components/Footer";
import { FloatingWhatsApp } from "../components/FloatingWhatsApp";
import { BookNowModal } from "../components/BookNowModal";

export default function Home() {
  useLenis();

  return (
    <div className="relative" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <MarqueeRibbon />
        <Reviews />
        <About />
        <Included />
        <AboutUs />
        <Rooms />
        <Gallery />
        <Location />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <BookNowModal />
    </div>
  );
}
